/**
 * Typography for a note's HTML, shared by saved note bodies and the note
 * composer so a note looks the same while typed and once saved. Tailwind's
 * preflight strips list and code styling, so each element the composer can
 * produce is styled here: paragraphs, bullet and numbered lists (nested too),
 * bold, inline code, links and @-mentions. Italic, underline and strike keep
 * their browser defaults.
 */
export const NOTE_BODY_CLASS =
  'whitespace-pre-line text-sm text-foreground [&_p]:mb-1.5 [&_p:last-child]:mb-0 [&_ul]:ml-4 [&_ul]:list-disc [&_ol]:ml-4 [&_ol]:list-decimal [&_ul_ul]:list-[circle] [&_li]:my-0.5 [&_a]:text-primary [&_a]:underline [&_strong]:font-semibold [&_code]:rounded [&_code]:bg-muted [&_code]:px-1 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-[0.85em] [&_.mention]:rounded [&_.mention]:bg-primary/10 [&_.mention]:px-1 [&_.mention]:font-medium [&_.mention]:text-primary'
